<template>
<div class="card mb-0 border-0 shadow-0 ">
    <div class="card-body text-center py-5 mb-5">
        <div class="mt-5 mb-3">
            <img src="@/assets/global_assets/images/coming-soon.png" class="" alt="" width="300px">
        </div>
        <h1 class="error-page-title">{{$t('Great Things Coming Soon…')}}</h1>
        <div class="error-page-text">
            <div width="400px">{{$t('The page you’re looking for is currently updating with a new version and will be back soon.')}}</div>          
        </div>
    </div>

</div>
</template>

<script>
export default {
    components: {},
    data() {
        return {

        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/tenancy/admin/error-page/templates/ComingSoon.vue